import { useNavigate } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses';
import { useSearchParams } from '../../common/hooks/useSearchParams';
import { selectCompanyHeaderMsg, selectCompanyMsg, t } from '../../common/i18n';
import { useAuth } from '../../public/site/AuthProvider';
import { Grid } from '../Grid/Grid';
import { getUserAccounts } from '../Header/dynamic/headerFunctions';
import { CompanySelector } from './CompanySelector';

export const CompanySelectorWithHeaderText = () => {
  const { authenticatedUser, setActiveAccount } = useAuth();
  const navigate = useNavigate();
  const { mdmId } = useSearchParams<{ mdmId: string }>();

  return (
    <Grid>
      <h3 className={dsClass.H3_BOOK}>{t.BR9A(selectCompanyHeaderMsg)}</h3>
      <CompanySelector
        userAccounts={getUserAccounts(authenticatedUser)}
        onInputChange={(_, option) => {
          setActiveAccount(option.accountMasterId!);
          navigate(`?mdmId=${option.accountMasterId}`, { replace: true });
        }}
        initialMdmId={mdmId}
        labelText={t.JUY2(selectCompanyMsg)}
        labelWeightNormal
      />
    </Grid>
  );
};
